import type { SVGProps } from 'react';

/** Italy — vertical green/white/red tricolour. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const ItFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="30" fill="#fff" />
        <rect width="20" height="30" fill="#009246" />
        <rect x="40" width="20" height="30" fill="#CE2B37" />
    </svg>
);
